/**
 * Joins class names, dropping anything falsy.
 *
 * Exists mainly because `noUncheckedIndexedAccess` types every CSS-module class
 * as `string | undefined`. That check is worth keeping for real data — catalog
 * lookups, cart lines — so the class-name case gets absorbed here rather than
 * loosening the compiler for the whole app.
 */
export function cx(...parts: Array<string | false | null | undefined>): string {
  return parts.filter(Boolean).join(' ');
}
